import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PALLETS_FEATURE_KEY } from '../keys';
import { PalletsState } from '../reducers/pallets.reducer';

const selectState = createFeatureSelector<PalletsState>(PALLETS_FEATURE_KEY);

export const selectPallets = createSelector(selectState, (state: PalletsState) => state.pallets);
export const selectStatus = createSelector(selectState, (state: PalletsState) => state.status);
export const selectPage = createSelector(selectState, (state: PalletsState) => state.page);
export const selectHasMore = createSelector(selectState, (state: PalletsState) => state.hasMore);
export const selectPallet = createSelector(selectState, (state: PalletsState) => state.pallet);
export const selectLoaded = createSelector(selectState, (state: PalletsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: PalletsState) => state.loading);
export const selectSaving = createSelector(selectState, (state: PalletsState) => state.saving);
